import object from 'helpers/object'


export const initialState = {
  list: [],
  isFetching: true,
}


export const setNews = (state, payload) => (
  object.setIn(state, [ 'list' ], payload)
)

export const setFetching = (state, payload) => (
  object.setIn(state, [ 'isFetching' ], payload)
)
